<div [@myAnimation]="o.isActivated ? o.activatedRoute : ''" [className]="!display?'d-none':''">
    <mat-progress-bar *ngIf="chkProgressBar" class="tp-margin" color="#db0c0c" mode="indeterminate" value="50" bufferValue="75">
    </mat-progress-bar>
    <app-header></app-header>
    <router-outlet #o="outlet"></router-outlet>
    <app-footer></app-footer>
</div>

<div class="pre-loader" *ngIf="!display">
    <img src="assets/images/loader.gif" alt="Please wait while loading..." class="img-fluid" alt="loader">
</div>